import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import Departments from '../Departments'; // Adjust the import path accordingly
import HomeContact from './HomeContact';

export default function Specialities() {

  // Combine medical and surgical departments
  const allDepartments = [...Departments.medical, ...Departments.surgical];
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top on mount
  }, []);
  return (
    <div>
      <title>
        List of Medical Specialties | Best Hospitals in Hyderabad
      </title>
      <meta name="description" content="Get treated at one of the best hospitals in Hyderabad. This Hyderabad famous hospital provides trusted care across a wide range of essential medical specialties." />
      <div className="py-20 max-w-[1200px] mx-auto">
        {/* Header Section */}
        <div className="mb-[56px] xl:mx-0 md:mx-16 mx-8 text-center flex justify-center">
          <h1 data-aos="fade-up" className=" text-[36px] md:text-[58px] leading-[1.138em] font-heading text-thickGreen mb-12 text-center max-w-[684px]">
            MagnAid Solutions for all your Health issues
          </h1>
        </div>

        {/* Grid of Department Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:mx-2 mx-4 xl:grid-cols-3 gap-6">
          {allDepartments.map((dept, index) => (
            <div
              key={index} data-aos="fade-up"
              className="bg-lightOrange lg:py-12 py-8 lg:px-8 px-4 rounded-3xl shadow-sm flex flex-col items-start"
            >
              <img
                src={dept.Icon}
                alt={dept.title}
                className="mb-6"
              />
              <h3 className=" text-[28px] text-thickGreen mb-4">
                {dept.title}
              </h3>
              <p className="text-paraGreen text-[20px] font-medium">
                {dept.cardDes}
              </p>
              <Link
                to={`/${dept.metaUrl}`} // URL-friendly format
                className="flex gap-3 items-center mt-6 text-thickGreen font-light font-body hover:text-thickGreen-dark"
              >

                <span className="text-[18px]">Learn more</span>
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </Link>
            </div>
          ))}
        </div>
      </div>
      <HomeContact />
    </div>
  );
}